import { RemoteCurrency } from '../models/Currency';

export const currencyUZS: RemoteCurrency = {
  id: -1,
  Code: '',
  Ccy: 'UZS',
  CcyNm_RU: 'Узбекский сум',
  CcyNm_UZ: "O'zbekiston so'mi",
  CcyNm_UZC: 'Ўзбекистон сўми',
  CcyNm_EN: 'Uzbek soum',
  CcyNm_TR: 'Uzbek soum',
  CcyNm_TJ: 'Суми Узбек',
  CcyNm_KY: 'Өзбекстан сому',
  Nominal: '1',
  Rate: '1',
  Diff: '',
  Date: ''
};

export const currencyTJS: RemoteCurrency = {
  id: -2,
  Code: '',
  Ccy: 'TJS',
  CcyNm_RU: 'Сомони',
  CcyNm_UZ: 'Tojikiston somonisi',
  CcyNm_UZC: 'Тожикистон сомониси',
  CcyNm_EN: 'Tajikistan Somoni',
  CcyNm_TR: 'Somoni',
  CcyNm_TJ: 'Сомонӣ',
  CcyNm_KY: 'Тажикстан сомониси',
  Nominal: '1',
  Rate: '1',
  Diff: '',
  Date: ''
};
